export const typeValues = ['m', 's', 'xs', 'xxs'];